// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.capacitaciones {
  height: calc(100vh - 110px) !important;
  overflow-y: scroll;
  overflow-x: hidden;
}
.capacitaciones .loading {
  position: absolute;
  top: 0;
  left: 361px;
  width: calc(100% - 370px);
  height: 100%;
  background: rgb(255, 255, 255);
  z-index: 1;
}
.capacitaciones .icon {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  width: 50px;
  height: 50px;
  border-radius: 50rem;
  padding: 8px;
  margin: 0 10px;
}
.capacitaciones .icon svg {
  fill: white;
  width: 100%;
}
.capacitaciones select {
  margin: 0 20px;
  border: 2px solid #8e8e8e;
  border-radius: 50rem !important;
  align-items: center;
  background: white;
  height: 35px;
  padding: 0 15px;
}
.capacitaciones .search {
  display: flex;
  border: 2px solid #8e8e8e;
  border-radius: 50rem;
  align-items: center;
  background: white;
  height: 35px;
  padding: 15px;
}
.capacitaciones input[type=text] {
  border: none;
  width: 100%;
  background: none;
}
.capacitaciones button {
  background: linear-gradient(45deg, #40c2ff 0%, #32d8d8 100%);
  border: none;
  border-radius: 50rem;
  padding: 0 10px;
  color: white;
  height: 35px;
  width: 100%;
}
.capacitaciones ul li {
  list-style: none;
  border-bottom: 2px solid #9a9a9a;
  padding: 10px 0;
  margin: 0;
}
.capacitaciones ul li.empty {
  background: #efefef;
  border: 1px solid #e1e1e1;
  color: #afafaf;
  font-weight: bold;
  border-radius: 5px;
  margin: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 5px 18px rgba(0, 0, 0, 0.05);
}
.capacitaciones ul li.table-body {
  padding: 0;
  border-bottom: 1px solid #eaeaea;
}
.capacitaciones ul li .header {
  color: #9a9a9a;
  font-weight: 500;
  font-size: 16px;
}
.capacitaciones ul li .table-body {
  font-size: 12px;
  font-weight: 500;
  color: #494949;
  margin-top: 5px;
}
.capacitaciones ul li .table-body.curse {
  font-size: 16px;
}
.capacitaciones ul li .table-body .plus {
  width: 30px;
  height: 30px;
  padding: 0;
  margin-left: 5px;
  background: none;
  color: #40c2ff;
}

.custom-dropdown-button {
  background-color: transparent;
  border-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/Views/Capacitaciones/capacitaciones.sass"],"names":[],"mappings":"AAAA;EACI,sCAAA;EACA,kBAAA;EACA,kBAAA;AACJ;AAAI;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EAEA,yBAAA;EACA,YAAA;EACA,8BAAA;EACA,UAAA;AACR;AACI;EACI,4DAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,YAAA;EACA,cAAA;AACR;AACQ;EACI,WAAA;EACA,WAAA;AACZ;AACI;EACI,cAAA;EACA,yBAAA;EACA,+BAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AACR;AACI;EACI,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;AACR;AACI;EACI,YAAA;EACA,WAAA;EACA,gBAAA;AACR;AACI;EACI,4DAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AACR;AACI;EACI,gBAAA;EACA,gCAAA;EACA,eAAA;EACA,SAAA;AACR;AACQ;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,0CAAA;AACZ;AACQ;EACI,UAAA;EACA,gCAAA;AACZ;AACQ;EACI,cAAA;EACA,gBAAA;EACA,eAAA;AACZ;AACQ;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AACZ;AACY;EACI,eAAA;AAChB;AACY;EACI,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AAChB;;AACA;EACE,6BAAA;EACA,yBAAA;AAEF","sourcesContent":[".capacitaciones\n    height: calc(100vh - 110px) !important\n    overflow-y: scroll\n    overflow-x: hidden\n    & .loading\n        position: absolute\n        top: 0\n        left: 361px\n\n        width: calc(100% - 370px)\n        height: 100%\n        background: rgba(255,255,255,1)\n        z-index: 1\n\n    & .icon\n        background: linear-gradient(45deg,#40c2ff 0%, #32d8d8 100%)\n        width: 50px\n        height: 50px\n        border-radius: 50rem\n        padding: 8px\n        margin: 0 10px\n\n        & svg\n            fill: white\n            width: 100%\n\n    & select\n        margin: 0 20px\n        border: 2px solid #8e8e8e\n        border-radius: 50rem!important\n        align-items: center\n        background: white\n        height: 35px\n        padding: 0 15px\n\n    & .search\n        display: flex\n        border: 2px solid #8e8e8e\n        border-radius: 50rem\n        align-items: center\n        background: white\n        height: 35px\n        padding: 15px\n\n    & input[type=\"text\"]\n        border: none\n        width: 100%\n        background: none\n\n    & button\n        background: linear-gradient(45deg,#40c2ff 0%, #32d8d8 100%)\n        border: none\n        border-radius: 50rem\n        padding: 0 10px\n        color: white\n        height: 35px\n        width: 100%\n\n    & ul li\n        list-style: none\n        border-bottom: 2px solid #9a9a9a\n        padding: 10px 0\n        margin: 0\n\n        &.empty\n            background: #efefef\n            border: 1px solid #e1e1e1\n            color: #afafaf\n            font-weight: bold\n            border-radius: 5px\n            margin: 50px\n            display: flex\n            align-items: center\n            justify-content: center\n            box-shadow: 0 5px 18px rgba(0,0,0,.05)\n\n        &.table-body\n            padding: 0\n            border-bottom: 1px solid #eaeaea\n\n        .header\n            color: #9a9a9a\n            font-weight: 500\n            font-size: 16px\n\n        .table-body\n            font-size: 12px\n            font-weight: 500\n            color: #494949\n            margin-top: 5px\n\n            &.curse\n                font-size: 16px\n\n            .plus\n                width: 30px\n                height: 30px\n                padding: 0\n                margin-left: 5px\n                background: none\n                color: #40c2ff\n\n.custom-dropdown-button \n  background-color: transparent\n  border-color: transparent\n\n\n\n.custom-list-group \n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
